import { memo } from 'react';

type LoginButtonProps = {
    text: string;
    icon: string;
    onClick: () => void;
    disabled?: boolean;
};

const LoginButton = memo(({ text, icon, onClick, disabled = false }: LoginButtonProps) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`w-[100%] h-[42px] px-4 border border-gray-300 bg-white flex items-center justify-center gap-2.5 whitespace-normal text-center relative transition-colors duration-100 ease-in max-[267px]:leading-tight rounded-full ${disabled
                    ? 'opacity-60 cursor-not-allowed'
                    : 'cursor-pointer hover:bg-gray-100'
                }`}
        >
            <span className="flex items-center z-[2]">
                <img 
                    src={icon} 
                    className="w-6 h-6 flex-shrink-0" 
                    alt="" 
                    loading="lazy"
                    onError={(e) => {
                        // Hide the image if it fails to load to prevent console errors
                        e.currentTarget.style.display = 'none';
                    }}
                />
            </span>
            <span className="flex-1 flex justify-center items-center z-[1]">
                {text}
            </span>
        </button>
    );
});

export default LoginButton;